import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const StyledTypographyHeader = styled(Typography)`
    display: flex;
    align-items: center;
    padding-bottom: ${({ theme }) => theme.spacing(1)}px;
`;

export const StyledStatistic = styled.span`
    display: inline-block;
    min-width: 45px;
    padding-right: ${({ theme }) => theme.spacing(0.5)}px;
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
    text-align: right;
`;
